module.exports = __webpack_public_path__ + "static/media/The-Ravines-Plymouth-By-Laws.5330c027.pdf";